import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectWithRadio } from '@components/SelectWithRadio';
import { LANGUAGE_OPTIONS } from '@config/languages.config';
import { COLORS } from '@constants/colors';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
export const ChooseLanguage = ({ value, onChange }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'flex-start', md: 'space-between' },
            alignItems: { xs: 'stretch', md: 'center' },
            gap: { xs: theme.spacing(2), md: 0 },
            border: `1px solid ${theme.palette.infoBox.border}`,
            px: { xs: theme.spacing(2), md: theme.spacing(3) },
            py: theme.spacing(2),
            boxShadow: COLORS.shadow.infoBox,
            borderRadius: '4px',
        }, children: [_jsx(Typography, { variant: "subtitle1", color: "primary", children: "Choose your language" }), _jsx(SelectWithRadio, { options: LANGUAGE_OPTIONS.map(lang => ({
                    label: lang.label,
                    value: lang.key,
                })), placeholder: "Select your language", value: value, onChange: onChange, fullWidth: isMobile })] }));
};
